"use strict";

var moment = require("moment");
var URLUtil = require("app/util/browser/url");

var getDefaultActivity = function getDefaultActivity(type) {
  var entityId = URLUtil.getEntityId(window.location.search);
  var activityInsideEntity = entityId && type == "activityInput";

  return {
    text: "",
    type: null,
    metrics: [],
    entity: null,
    date: activityInsideEntity ? null : moment().format("YYYY-MM-DD"),
    time: activityInsideEntity ? null :"23:59:59",
    selectedUsers: [{
      id: window.loggedUserId,
      name: window.loggedUserName,
      avatarURL: window.loggedUserAvatarURL,
      checked: true
    }]
  };
};

var storageItemName = function () {
  var entityId = URLUtil.getEntityId(window.location.search);
  var env = URLUtil.getPageEnv(window.location);

  if (entityId) {
    return window.loggedUserId + "/" + env + "/" + entityId + "/newTask";
  } else {
    return window.loggedUserId + "/" + env + "/newTask";
  }
};

var handleActivityFromSchedule = function (activity) {
  var scheduleActivity = activity;
  if (activity.date == null || activity.time == null) {
    scheduleActivity.date = getDefaultActivity("schedule").date;
    scheduleActivity.time = getDefaultActivity("schedule").time;
  }
  return scheduleActivity;
};

module.exports.saveActivity = function saveActivity(activity) {
  try {
    localStorage.setItem(storageItemName(), JSON.stringify(activity));
  } catch (error) {
    captureError(error);
  }
};

module.exports.getActivity = function getActivity(type = "activityInput") {
  try {
    var activity = JSON.parse(localStorage.getItem(storageItemName()));
    if (type == "schedule" && activity) {
      activity = handleActivityFromSchedule(activity);
    }
    return activity || getDefaultActivity(type);
  } catch (error) {
    captureError(error);
  }
};

module.exports.removeActivity = function removeActivity() {
  try {
    localStorage.removeItem(storageItemName());
  } catch (error) {
    captureError(error);
  }
};



// WEBPACK FOOTER //
// ./app/util/browser/activity-draft.js